var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-detail flex" },
    [
      _c("transition", { attrs: { name: "component-fade", mode: "out-in" } }, [
        _vm.ready && _vm.product != null
          ? _c("div", { key: "ready", staticClass: "flex-1 pt-24" }, [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "row lg:mb-24 lg:items-end mb-16" }, [
                  _c(
                    "div",
                    {
                      staticClass: "w-full",
                      class:
                        _vm.firstQuestionsSections != null ? "lg:w-8/12" : ""
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "h-30 no-scrollbars relative w-full overflow-scroll"
                        },
                        [
                          _c("breadcrumbs", {
                            staticClass: "absolute top-0 left-0",
                            attrs: { breadcrumbs: _vm.breadcrumbs }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("h1", {
                        staticClass: "h4",
                        domProps: { innerHTML: _vm._s(_vm.product.name) }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.firstQuestionsSections != null
                    ? _c(
                        "div",
                        { staticClass: "lg:flex justify-end hidden w-4/12" },
                        [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "scroll-to",
                                  rawName: "v-scroll-to",
                                  value: {
                                    el:
                                      "#questions_" +
                                      _vm.orderedSections.indexOf(
                                        _vm.firstQuestionsSections
                                      ),
                                    offset: -_vm.$root.scrollOffset
                                  },
                                  expression:
                                    "{ el: `#questions_${orderedSections.indexOf(firstQuestionsSections)}`, offset: -$root.scrollOffset }"
                                }
                              ],
                              staticClass:
                                "btn btn-rounded btn-lg btn-outline-blue",
                              attrs: {
                                href:
                                  "#questions_" +
                                  _vm.orderedSections.indexOf(
                                    _vm.firstQuestionsSections
                                  )
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.translations.button_questions_label)
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "md:flex-row md:items-center md:mb-40 flex flex-col mb-24"
                  },
                  [
                    false
                      ? _c(
                          "div",
                          { staticClass: "lg:mb-0 flex items-center mb-8" },
                          [
                            _c("score-stars", {
                              staticClass: "mr-16",
                              attrs: { score: 4 }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "text-14 text-gray-400" },
                              [_vm._v("23 beoordelingen")]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "md:flex-row flex flex-col" },
                      [
                        _vm._l(_vm.translations.product_usps, function(
                          usp,
                          index
                        ) {
                          return [
                            _c(
                              "span",
                              {
                                key: "description_" + index,
                                staticClass:
                                  "text-14 last:mb-0 md:mb-0 mb-8 text-gray-400"
                              },
                              [_vm._v(_vm._s(usp.description))]
                            ),
                            _vm._v(" "),
                            index !== _vm.translations.product_usps.length - 1
                              ? _c(
                                  "span",
                                  {
                                    key: "bull_" + index,
                                    staticClass:
                                      "text-14 md:inline-block hidden mx-8 text-gray-400"
                                  },
                                  [_vm._v("•")]
                                )
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.firstQuestionsSections != null
                  ? _c("div", { staticClass: "md:hidden mb-40" }, [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "scroll-to",
                              rawName: "v-scroll-to",
                              value: {
                                el:
                                  "#questions_" +
                                  _vm.orderedSections.indexOf(
                                    _vm.firstQuestionsSections
                                  ),
                                offset: -_vm.$root.scrollOffset
                              },
                              expression:
                                "{ el: `#questions_${orderedSections.indexOf(firstQuestionsSections)}`, offset: -$root.scrollOffset }"
                            }
                          ],
                          staticClass:
                            "btn btn-rounded btn-lg btn-outline-blue",
                          attrs: {
                            href:
                              "#questions_" +
                              _vm.orderedSections.indexOf(
                                _vm.firstQuestionsSections
                              )
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.translations.button_questions_label)
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-60 lg:mb-80" }, [
                  _c(
                    "div",
                    { staticClass: "md:w-7/12 lg:mb-0 w-full mb-24" },
                    [
                      _c("media-gallery", {
                        attrs: { media: _vm.orderedMedia }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "md:w-5/12 w-full" }, [
                    _c("div", { staticClass: "md:pl-40" }, [
                      _c("div", {
                        staticClass:
                          "product-description lg:mb-40 mb-32 font-medium text-gray-500",
                        domProps: { innerHTML: _vm._s(_vm.product.description) }
                      }),
                      _vm._v(" "),
                      _c("hr", { staticClass: "lg:mb-32 mb-24" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "lg:mb-32 mb-24" },
                        _vm._l(_vm.productOptionsWithoutOppCalc, function(
                          option
                        ) {
                          return _c(
                            "div",
                            { key: option.key, staticClass: "last:mb-0 mb-16" },
                            [
                              option.filterable
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-14 lead inline-block mb-8 text-gray-400"
                                    },
                                    [_vm._v(_vm._s(option.name))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              option.filterable
                                ? _c(
                                    "div",
                                    { staticClass: "flex flex-wrap -mb-8" },
                                    _vm._l(
                                      _vm.getPossibleOptions(option),
                                      function(value, index) {
                                        return _c(
                                          "a",
                                          {
                                            key: index,
                                            staticClass:
                                              "btn btn-sm btn-rounded last:mr-0 mb-8 mr-8",
                                            class:
                                              _vm.activeVariant.content[
                                                option.key
                                              ] == value
                                                ? "btn-green"
                                                : "btn-outline-gray-400",
                                            attrs: { href: "#" },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.changeVariant(
                                                  option,
                                                  value
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(value))]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e()
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex items-end mb-8" }, [
                        _c(
                          "span",
                          { staticClass: "text-40 mr-8 font-semibold" },
                          [
                            _vm._v(
                              "€ " +
                                _vm._s(
                                  _vm.getActiveVariantPrice(
                                    _vm.$store.getters["pricesIncludingVat"]
                                  )
                                )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.$store.getters["pricesIncludingVat"]
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "text-12 pb-10 font-semibold text-gray-400"
                              },
                              [_vm._v(_vm._s(_vm.translations.vat_included))]
                            )
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "text-12 pb-10 font-semibold text-gray-400"
                              },
                              [_vm._v(_vm._s(_vm.translations.vat_excluded))]
                            )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex items-end mb-16" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "text-12 mr-2 font-semibold text-gray-400"
                          },
                          [
                            _vm._v(
                              "€ " +
                                _vm._s(
                                  _vm.getActiveVariantPrice(
                                    !_vm.$store.getters["pricesIncludingVat"]
                                  )
                                )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.$store.getters["pricesIncludingVat"]
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "text-10 font-semibold text-gray-400"
                              },
                              [_vm._v(_vm._s(_vm.translations.vat_included))]
                            )
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "text-10 font-semibold text-gray-400"
                              },
                              [_vm._v(_vm._s(_vm.translations.vat_excluded))]
                            )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-12 flex flex-wrap items-center font-semibold leading-tight text-gray-400"
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "text-12 inline-block mx-8 mb-8",
                              class: _vm.activeVariantInStock
                                ? "text-green"
                                : "text-red"
                            },
                            [_vm._v("•")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "mb-8" }, [
                            _vm._v(
                              _vm._s(
                                _vm.activeVariantInStock
                                  ? _vm.translations.in_stock
                                  : _vm.translations.not_in_stock
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm.activeVariant.volume_prices != null &&
                          _vm.activeVariant.volume_prices.length > 1
                            ? [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-10 inline-block mx-8 mb-8"
                                  },
                                  [_vm._v("•")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "mb-8" }, [
                                  _vm._v(
                                    "Korting vanaf " +
                                      _vm._s(
                                        _vm.activeVariant.volume_prices[1].from
                                      ) +
                                      " stuks"
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-10 inline-block mx-8 mb-8"
                                  },
                                  [_vm._v("•")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "scroll-to",
                                        rawName: "v-scroll-to",
                                        value: {
                                          el: "#prijzen-afmetingen",
                                          offset: -_vm.$root.scrollOffset
                                        },
                                        expression:
                                          "{ el: '#prijzen-afmetingen', offset: -$root.scrollOffset }"
                                      }
                                    ],
                                    staticClass:
                                      "hover:border-transparent mb-8 transition border-b border-gray-400",
                                    attrs: { href: "#prijzen-afmetingen" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.translations.discover_discount)
                                    )
                                  ]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      !_vm.showSurfaceCalculator
                        ? _c(
                            "div",
                            { staticClass: "lg:mt-40 flex flex-wrap mt-16" },
                            [
                              _c("a", {
                                staticClass: "decrease mr-8",
                                attrs: { href: "#" },
                                domProps: {
                                  innerHTML: _vm._s(_vm.svg("minus"))
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.decreaseAmount($event)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.addAmount,
                                    expression: "addAmount"
                                  }
                                ],
                                staticClass:
                                  "add-amount mr-8 text-center appearance-none",
                                attrs: { type: "number" },
                                domProps: { value: _vm.addAmount },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.addAmount = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("a", {
                                staticClass: "increase lg:mr-16",
                                attrs: { href: "#" },
                                domProps: {
                                  innerHTML: _vm._s(_vm.svg("plus"))
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.increaseAmount($event)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-rounded btn-green lg:w-auto xl:mt-0 w-full mt-8",
                                  attrs: {
                                    disabled: !_vm.activeVariantInStock
                                  },
                                  on: { click: _vm.addToCart }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.translations.add_product_button)
                                  )
                                ]
                              )
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "rounded-xs surface-calculator lg:mt-32 p-24 mt-16 bg-gray-100"
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-20 mb-56 font-bold leading-tight"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.translations.calculate_surface)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex items-center mb-16" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "surface relative flex flex-1"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bottom-full text-14 absolute font-medium text-gray-500 transform -translate-y-16"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.translations.surface)
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.localSurface,
                                            expression: "localSurface"
                                          }
                                        ],
                                        staticClass: "flex-1 appearance-none",
                                        attrs: { type: "number" },
                                        domProps: { value: _vm.localSurface },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.localSurface =
                                                $event.target.value
                                            },
                                            _vm.calculateNeededAmount
                                          ]
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-14 inline-block mx-10 font-medium text-gray-500"
                                    },
                                    [_vm._v("=")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "relative flex flex-1" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bottom-full text-14 absolute font-medium text-gray-500 transform -translate-y-16"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.translations.pieces)
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.addAmount,
                                            expression: "addAmount"
                                          }
                                        ],
                                        staticClass: "flex-1 appearance-none",
                                        attrs: { type: "number" },
                                        domProps: { value: _vm.addAmount },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.addAmount =
                                                $event.target.value
                                            },
                                            _vm.calculateSurfaceOfAmount
                                          ]
                                        }
                                      })
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("el-input", {
                                staticClass: "mb-16",
                                attrs: {
                                  type: "checkbox",
                                  label:
                                    _vm.translations
                                      .surface_calculator_disclaimer
                                },
                                model: {
                                  value: _vm.applyCuttingLoss,
                                  callback: function($$v) {
                                    _vm.applyCuttingLoss = $$v
                                  },
                                  expression: "applyCuttingLoss"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-rounded btn-green w-full",
                                  attrs: {
                                    disabled: !_vm.activeVariantInStock
                                  },
                                  on: { click: _vm.addToCart }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.translations.add_product_button)
                                  )
                                ]
                              )
                            ],
                            1
                          )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mb-60 lg:mb-80" },
                  [_vm._t("usps")],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "lg:flex hidden mb-16" },
                  [
                    Object.keys(_vm.mappedOptions).length > 0
                      ? _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "smooth-scroll",
                                rawName: "v-smooth-scroll",
                                value: { offset: -_vm.$root.headerHeight },
                                expression: "{ offset: -$root.headerHeight }"
                              }
                            ],
                            staticClass:
                              "last:mr-0 hover:text-green mr-32 transition-colors",
                            attrs: { href: "#prijzen-afmetingen" }
                          },
                          [_vm._v(_vm._s(_vm.translations.pricing_sizing))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.orderedSections, function(section, index) {
                      return _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "smooth-scroll",
                              rawName: "v-smooth-scroll",
                              value: { offset: -_vm.$root.headerHeight },
                              expression: "{ offset: -$root.headerHeight }"
                            }
                          ],
                          key: index,
                          staticClass:
                            "last:mr-0 hover:text-green mr-32 transition-colors",
                          attrs: { href: "#" + section.type + "_" + index }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              section.content.title != ""
                                ? section.content.title
                                : _vm.translations[section.type]
                            )
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("hr", { staticClass: "lg:block hidden mb-40" }),
              _vm._v(" "),
              Object.keys(_vm.mappedOptions).length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "mb-60 lg:mb-80 last:mb-0",
                      attrs: { id: "prijzen-afmetingen" }
                    },
                    [
                      _c("div", { staticClass: "container" }, [
                        _c("h2", { staticClass: "h4 mb-32" }, [
                          _vm._v(_vm._s(_vm.translations.pricing_sizing))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "w-screen pr-20 overflow-x-scroll" },
                        [
                          _c("div", { staticClass: "container" }, [
                            _c(
                              "table",
                              { staticClass: "block w-full text-left" },
                              [
                                _c("thead", [
                                  _c(
                                    "tr",
                                    { staticClass: "border-b border-gray-100" },
                                    [
                                      _vm._l(
                                        Object.keys(_vm.mappedOptions),
                                        function(option) {
                                          return [
                                            _c(
                                              "th",
                                              {
                                                key: option,
                                                staticClass:
                                                  "text-12 first:pl-8 pb-16 font-bold text-gray-500"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.mappedOptions[option]
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      ),
                                      _vm._v(" "),
                                      _vm.product.volume_discounts == null ||
                                      _vm.product.volume_discounts.length == 0
                                        ? _c(
                                            "th",
                                            {
                                              staticClass:
                                                "text-12 pb-16 font-bold text-gray-500"
                                            },
                                            [_vm._v("Prijs")]
                                          )
                                        : _vm._l(
                                            _vm.product.volume_discounts,
                                            function(discount, index) {
                                              return _c(
                                                "th",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "text-12 pb-16 font-bold text-gray-500"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      index + 1 ===
                                                        _vm.product
                                                          .volume_discounts
                                                          .length
                                                        ? ">" +
                                                            discount.from +
                                                            " stuks"
                                                        : discount.from +
                                                            " - " +
                                                            (_vm.product
                                                              .volume_discounts[
                                                              index + 1
                                                            ].from -
                                                              1) +
                                                            " stuks"
                                                    )
                                                  )
                                                ]
                                              )
                                            }
                                          )
                                    ],
                                    2
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(_vm.product.variants, function(
                                    variant,
                                    index
                                  ) {
                                    return _c(
                                      "tr",
                                      {
                                        key: index,
                                        class: {
                                          "bg-gray-100": index % 2 !== 0
                                        }
                                      },
                                      [
                                        _vm._l(
                                          Object.keys(_vm.mappedOptions),
                                          function(option) {
                                            return [
                                              _c(
                                                "td",
                                                {
                                                  key:
                                                    variant.ean + "_" + option,
                                                  staticClass:
                                                    "text-14 first:pl-8 py-16"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      variant.content[
                                                        _vm.parseOption(option)
                                                          .key
                                                      ]
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        ),
                                        _vm._v(" "),
                                        _vm.product.volume_discounts == null ||
                                        _vm.product.volume_discounts.length == 0
                                          ? _c(
                                              "td",
                                              {
                                                key: variant.ean + "_price",
                                                staticClass: "text-14 py-16"
                                              },
                                              [
                                                _vm._v(
                                                  "€ " +
                                                    _vm._s(
                                                      _vm.$store.getters[
                                                        "pricesIncludingVat"
                                                      ]
                                                        ? _vm.formatCurrency(
                                                            variant.price_vat_incl
                                                          )
                                                        : _vm.formatCurrency(
                                                            variant.price
                                                          )
                                                    )
                                                )
                                              ]
                                            )
                                          : _vm._l(
                                              variant.volume_prices,
                                              function(volume) {
                                                return _c(
                                                  "td",
                                                  {
                                                    key:
                                                      variant.ean +
                                                      "_volume_" +
                                                      volume.from +
                                                      "_price",
                                                    staticClass: "text-14 py-16"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "€ " +
                                                        _vm._s(
                                                          _vm.$store.getters[
                                                            "pricesIncludingVat"
                                                          ]
                                                            ? _vm.formatCurrency(
                                                                volume.price_vat_incl
                                                              )
                                                            : _vm.formatCurrency(
                                                                volume.price
                                                              )
                                                        )
                                                    )
                                                  ]
                                                )
                                              }
                                            )
                                      ],
                                      2
                                    )
                                  }),
                                  0
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "text-12 pb-10 font-semibold text-gray-400"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$store.getters["pricesIncludingVat"]
                                      ? _vm.$t("default.prices_including_vat")
                                      : _vm.$t("default.prices_excluding_vat")
                                  )
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "container" }, [
                _c(
                  "div",
                  { staticClass: "-mx-30 -mb-60 lg:-mb-80 flex flex-wrap" },
                  [
                    _vm._l(_vm.orderedSections, function(section, index) {
                      return [
                        section.type === "description"
                          ? _c(
                              "div",
                              {
                                key: section.type + "_" + index,
                                staticClass: "px-30 mb-60 lg:mb-80 w-full",
                                attrs: { id: section.type + "_" + index }
                              },
                              [
                                _c("h2", { staticClass: "h4 mb-16" }, [
                                  _vm._v(
                                    _vm._s(
                                      section.content.title != ""
                                        ? section.content.title
                                        : _vm.translations.description
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "lg:w-7/12 w-full" },
                                    [
                                      _c("p", {
                                        staticClass: "wysiwyg text-gray-500",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            section.content.description
                                          )
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        section.type === "related_products" &&
                        section.products.length > 0
                          ? _c(
                              "div",
                              {
                                key: section.type + "_" + index,
                                staticClass: "px-30 mb-60 lg:mb-80 w-full",
                                attrs: { id: section.type + "_" + index }
                              },
                              [
                                _c("h2", { staticClass: "h4 mb-32" }, [
                                  _vm._v(
                                    _vm._s(
                                      section.content.title != ""
                                        ? section.content.title
                                        : _vm.translations.related_products
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "-mx-30 -mb-60 flex flex-wrap"
                                  },
                                  _vm._l(section.products, function(product) {
                                    return _c(
                                      "div",
                                      {
                                        key: product.id,
                                        staticClass:
                                          "px-30 mb-60 md:w-1/2 w-full"
                                      },
                                      [
                                        _c("associated-product", {
                                          attrs: { "product-id": product }
                                        })
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        section.type === "comparable_products" &&
                        section.products.length > 0
                          ? _c(
                              "div",
                              {
                                key: section.type + "_" + index,
                                staticClass: "px-30 mb-60 lg:mb-80 w-full",
                                attrs: { id: section.type + "_" + index }
                              },
                              [
                                _c("h2", { staticClass: "h4 lg:mb-32 mb-24" }, [
                                  _vm._v(
                                    _vm._s(
                                      section.content.title != ""
                                        ? section.content.title
                                        : _vm.translations.comparable_products
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row -mb-32" },
                                  _vm._l(section.products, function(
                                    relatedProduct
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: relatedProduct.id,
                                        staticClass:
                                          "lg:w-1/4 md:w-1/3 flex w-1/2 mb-32"
                                      },
                                      [
                                        _c("lazy-product-card", {
                                          attrs: {
                                            "product-id": relatedProduct
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        section.type === "technicals"
                          ? _c(
                              "div",
                              {
                                key: section.type + "_" + index,
                                staticClass: "px-30 mb-60 lg:mb-80 w-full",
                                attrs: { id: section.type + "_" + index }
                              },
                              [
                                _c("h2", { staticClass: "h4 mb-32" }, [
                                  _vm._v(
                                    _vm._s(
                                      section.content.title != ""
                                        ? section.content.title
                                        : _vm.translations.technicals
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "-mx-30 flex flex-wrap" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "px-30 lg:w-1/2 lg:mb-0 w-full mb-40"
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "wysiwyg leading-relaxed text-gray-500",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              section.content.description_1
                                            )
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "px-30 lg:w-1/2" },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "wysiwyg leading-relaxed text-gray-500",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              section.content.description_2
                                            )
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        section.type === "media"
                          ? _c(
                              "div",
                              {
                                key: section.type + "_" + index,
                                staticClass: "px-30 mb-60 lg:mb-80 w-full",
                                attrs: { id: section.type + "_" + index }
                              },
                              [
                                _c("h2", { staticClass: "h4 mb-32" }, [
                                  _vm._v(
                                    _vm._s(
                                      section.content.title != ""
                                        ? section.content.title
                                        : _vm.translations.media
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("video-section", {
                                  attrs: { media: section.media }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        section.type === "placement"
                          ? _c(
                              "div",
                              {
                                key: section.type + "_" + index,
                                staticClass:
                                  "px-30 md:w-1/2 mb-60 lg:mb-80 w-full",
                                attrs: { id: section.type + "_" + index }
                              },
                              [
                                _c("h2", { staticClass: "h4 mb-32" }, [
                                  _vm._v(
                                    _vm._s(
                                      section.content.title != ""
                                        ? section.content.title
                                        : _vm.translations.placement_info
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("video-section", {
                                  attrs: { media: section.media, single: true }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        section.type === "manuals"
                          ? _c(
                              "div",
                              {
                                key: section.type + "_" + index,
                                staticClass:
                                  "px-30 md:w-1/2 mb-60 lg:mb-80 w-full",
                                attrs: { id: section.type + "_" + index }
                              },
                              [
                                _c("h2", { staticClass: "h4 mb-32" }, [
                                  _vm._v(
                                    _vm._s(
                                      section.content.title != ""
                                        ? section.content.title
                                        : _vm.translations.documents
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("download-list", {
                                  attrs: { media: section.media }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        section.type === "reviews" &&
                        section.reviews != null &&
                        section.reviews.length > 0
                          ? _c(
                              "div",
                              {
                                key: section.type + "_" + index,
                                staticClass: "px-30 mb-60 lg:mb-80 w-full",
                                attrs: { id: section.type + "_" + index }
                              },
                              [
                                _c("reviews", {
                                  attrs: {
                                    reviews: section.reviews,
                                    translations: _vm.reviewData
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        section.type === "questions"
                          ? [
                              _c(
                                "div",
                                {
                                  key: section.type + "_form_" + index,
                                  staticClass:
                                    "px-30 lg:w-1/2 mb-60 lg:mb-80 w-full",
                                  attrs: { id: section.type + "_" + index }
                                },
                                [
                                  _c("h2", { staticClass: "h4 mb-32" }, [
                                    _vm._v(
                                      _vm._s(_vm.translations.ask_question)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("contact-form", {
                                    attrs: {
                                      product: _vm.product.slug,
                                      translations: _vm.formData
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  key: section.type + "_faq_" + index,
                                  staticClass:
                                    "px-30 lg:w-1/2 mb-60 lg:mb-80 w-full"
                                },
                                [
                                  _c(
                                    "h2",
                                    { staticClass: "h4 lg:mb-32 mb-24" },
                                    [_vm._v(_vm._s(_vm.translations.faq))]
                                  ),
                                  _vm._v(" "),
                                  _c("faq", {
                                    attrs: { "faq-data": _vm.faqData }
                                  })
                                ],
                                1
                              )
                            ]
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              ])
            ])
          : _c(
              "div",
              {
                key: "loading",
                staticClass: "flex items-center justify-center flex-1"
              },
              [_c("spinner")],
              1
            )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }